import axios from "axios";

export default {
  namespaced: true,
  state: {
    salesorders: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    salesordersMessage: ''
  },
  mutations: {
    CLEAR_SALESORDERS(state) {
      state.salesorders = [];
    },
    RECEIVED_SALESORDERS(state, payload) {
      state.salesorders = payload;
      state.isReceiving = false;
    },
    RECEIVED_SALESORDER(state, payload) {
      let find = state.salesorders.find(i=>i._id==payload._id);
      state.isReceiving = false;
      if(find==null){
        state = Object.assign(state, { salesorders: [payload, ...state.salesorders] });
      }
      else {
        let index = state.salesorders.findIndex(salesorder => salesorder._id === payload._id);
        state.salesorders.splice(index, 1, payload);
      }
    },
    RECEIVING_SALESORDERS(state) {
      state.isReceiving = true;
    },
    RECEIVING_TRANSACTIONS(state) {
      state.isReceiving = true;
    },
    RECEIVED_TRANSACTIONS(state) {
      state.isReceiving = false;
    },

    RECEIVING_SALESORDER(state) {
      state.isReceiving = true;
    },
    UPDATED_SALESORDER(state, payload) {
      let index = state.salesorders.findIndex(salesorder => salesorder._id === payload._id);
      state = Object.assign(state, {
        salesorders: state.salesorders.map((salesorder, i) => {
          if (i === index) {
            return Object.assign({}, salesorder, payload);
          }
          return salesorder;
        }),
        isUpdating: false,
        salesordersMessage: 'SalesOrders has been updating!',
      })
    },
    UPDATING_SALESORDER(state) {
      state.isUpdating = true;
    },
    DELETED_SALESORDER(state, payload) {
      let indexToDelete = state.salesorders.findIndex(salesorder => salesorder._id === payload._id);
      let salesorders = [...state.salesorders];
      salesorders.splice(indexToDelete, 1);
      state = Object.assign(state, {
        salesorders: [...salesorders],
        isDeleting: false,
        idToDelete: null,
        salesordersMessage: 'SalesOrder has been Deleted!',
      });
    },
    DELETING_SALESORDER(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteSalesOrderRequest({dispatch}, payload) {
      dispatch("deletingSalesOrder", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.accountxc.com:3100/delete/salesorder/' + payload._id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "delete", url: url, headers: headers})
      .then(response=>{
        dispatch("deleteSalesOrder", {_id: response.data._id});
      })
      .catch(error=>{
        console.log(error.data);
      });
    },
    async deleteSOTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        let token = localStorage.getItem("token");
        let url = "https://api.accountxc.com:3100/delete/sotransaction/" + payload._id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){return null}
    },
    async insertSalesOrderRequest({dispatch}, payload) {
      dispatch("receivingSalesOrders");
      var token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/salesorder';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      
      let response = await axios({method: "post", url: url, headers: headers, data: data});
      console.log('so', response.data);
      dispatch("receiveSalesOrder", response.data);
      return response.data;
    },
    async insertSOTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        delete payload['branditems'];
        delete payload['_id'];
        let token = localStorage.getItem("token");
        let url = "https://api.accountxc.com:3100/insert/sotransaction/" + payload.salesorderid;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "post", url: url, headers: headers, data: payload });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){console.log(e)}
    },
    async getSalesOrdersRequest({dispatch}) {
      dispatch("receivingSalesOrders");
      let token = localStorage.getItem('token');
      console.log(token);
      let url = 'https://api.accountxc.com:3100/get/salesorders';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: header})
      .then(res => {
        dispatch("receiveSalesOrders", res.data);
      })
    },
    async getSalesOrdersTeamRequest({dispatch}) {
      dispatch("receivingSalesOrders");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/salesorders/team';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: header})
      .then(response => {
        console.log(response.data)
        dispatch("receiveSalesOrders", response.data);
      })
    },
    async findSalesOrdersRequest({dispatch}, payload) {
      try{
        dispatch("receivingSalesOrders");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/find/salesorders';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveSalesOrders", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async findSalesOrdersTeamRequest({dispatch}, payload) {
      try{
        dispatch("receivingSalesOrders");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/find/salesorders/team';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveSalesOrders", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateSalesOrderRequest({dispatch}, payload) {
      dispatch("updatingSalesOrder");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/salesorder/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers, data: payload})
      .then((response)=> {
        dispatch("updateSalesOrder", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    async updateSalesOrderProcessingRequest({dispatch}, payload) {
      dispatch("updatingSalesOrder");
      var id = payload._id;
      delete payload['_id'];
      var token = localStorage.getItem('token');
      var url = 'https://api.accountxc.com:3100/update/salesorder/processing/' + id;
      var header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      let response = await axios({method:"put", url:url, headers:header, data:payload})
      dispatch("updateSalesOrder", response.data);
      return response.data;
    },
    async updateSalesOrderTransaction({dispatch}, payload) {
      try{
        dispatch("receivingSalesOrder");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/update/sotransaction/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("receivingSalesOrder", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    clearSalesOrders({commit}) {
      commit("CLEAR_SALESORDERS")
    },
    receiveSalesOrders({commit}, payload) {
      commit("RECEIVED_SALESORDERS", payload)
    },
    receiveSalesOrder({commit}, payload) {
      commit("RECEIVED_SALESORDER", payload)
    },
    receivingSalesOrders({commit}) {
      commit("RECEIVING_SALESORDERS")
    },
    receivingTransactions({commit}) {
      commit("RECEIVING_TRANSACTIONS")
    },
    receiveTransactions({commit}) {
      commit("RECEIVED_TRANSACTIONS")
    },

    receivingSalesOrder({commit}) {
      commit("RECEIVING_SALESORDER")
    },
    updateSalesOrder({commit}, payload) {
      commit("UPDATED_SALESORDER", payload)
    },
    updatingSalesOrder({commit}) {
      commit("UPDATING_SALESORDER")
    },
    deleteSalesOrder({commit}, payload) {
      commit("DELETED_SALESORDER", payload)
    },
    deletingSalesOrder({commit}, payload) {
      commit("DELETING_SALESORDER", payload)
    }
  },
};
